import Script from 'next/script';

export const TvScript = () => {
  return <Script id='tv-datafeeds' src='/datafeeds/bundle.js' />;
};
